// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chimecho: PokeData = {
  "id": 358,
  "name": "chimecho",
  "height": 6,
  "weight": 10,
  "base_experience": 159,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "wrap",
    "take-down",
    "double-edge",
    "growl",
    "confusion",
    "psychic",
    "hypnosis",
    "recover",
    "light-screen",
    "psywave",
    "heal-bell",
    "safeguard",
    "uproar",
    "yawn",
    "astonish",
    "extrasensory",
    "healing-wish",
    "last-resort",
    "ominous-wind",
    "synchronoise",
    "entrainment",
    "stored-power",
    "heal-pulse"
  ],
  "moves": [
    "tackle",
    "growl",
    "psychic",
    "psywave",
    "heal-bell",
    "healing-wish",
    "reflect",
    "psychic-fangs",
    "kinesis",
    "calm-mind",
    "psychic-terrain",
    "prismatic-cage",
    "future-sight"
  ],
  "evolution_chain": {
    "id": 184,
    "item": {
      "name": "pure-incense"
    },
    "species": [
      {
        "name": "chingling",
        "order": 387,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "chimecho",
        "order": 388,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 433,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 220,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 108,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
